(() => {
  if (window.productAccordionInitialized) return;
  window.productAccordionInitialized = true;

  const SELECTOR = '.product__group--accordions .product__accordion > details';
  const HEIGHT_DURATION = 400;
  const FADE_DURATION = 300;
  // How far into the first step the second step starts (0 = together, 1 = strictly one after the other).
  const STAGGER = 0.7;
  const EASING = 'cubic-bezier(0.4, 0, 0.2, 1)';
  const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

  // While animating, `details.open` stays true until a close finishes, so track the intended state.
  const isOpen = (details) => details._accordionTarget ?? details.open;

  function toggle(details, open) {
    const summary = details.querySelector('summary');
    const content = details.querySelector('.accordion__content');
    // Set before measuring so the content's bottom margin is counted the same way in every measurement.
    details.style.overflow = 'hidden';
    const startHeight = details.offsetHeight;
    const startOpacity = details.open && content ? Number(getComputedStyle(content).opacity) : 0;

    details._accordionAnimations?.forEach((animation) => animation.cancel());
    details._accordionAnimations = null;
    details.parentElement.classList.toggle('is-open', open);

    if (reducedMotion.matches || !content) {
      details._accordionTarget = null;
      details.open = open;
      details.style.overflow = '';
      return;
    }

    details._accordionTarget = open;
    details.open = true;
    const closedHeight = summary.offsetHeight;
    const openHeight = details.offsetHeight;
    const endHeight = open ? openHeight : closedHeight;

    // Scale durations by the distance left, so an interrupted animation continues at the same pace.
    const heightProgress = Math.abs(endHeight - startHeight) / Math.max(openHeight - closedHeight, 1);
    const heightDuration = HEIGHT_DURATION * heightProgress;
    const fadeDuration = FADE_DURATION * Math.abs((open ? 1 : 0) - startOpacity);

    // Open: grow the height, then fade the content in. Close: fade the content out, then shrink the height.
    const heightDelay = open ? 0 : fadeDuration * STAGGER;
    const fadeDelay = open ? heightDuration * STAGGER : 0;

    const animations = [
      details.animate(
        { height: [`${startHeight}px`, `${endHeight}px`] },
        { duration: heightDuration, delay: heightDelay, easing: EASING, fill: 'both' }
      ),
      content.animate(
        { opacity: [startOpacity, open ? 1 : 0] },
        { duration: fadeDuration, delay: fadeDelay, easing: EASING, fill: 'both' }
      ),
    ];
    details._accordionAnimations = animations;

    Promise.all(animations.map((animation) => animation.finished))
      .then(() => {
        if (details._accordionAnimations !== animations) return;
        details.open = open;
        details._accordionTarget = null;
        details._accordionAnimations = null;
        animations.forEach((animation) => animation.cancel());
        details.style.overflow = '';
      })
      .catch(() => {});
  }

  document.addEventListener('click', (event) => {
    const summary = event.target.closest('summary');
    const details = summary?.parentElement;
    if (!details || !details.matches(SELECTOR)) return;

    event.preventDefault();
    const willOpen = !isOpen(details);

    if (willOpen) {
      details
        .closest('.product__group--accordions')
        .querySelectorAll(SELECTOR)
        .forEach((other) => {
          if (other !== details && isOpen(other)) toggle(other, false);
        });
    }

    toggle(details, willOpen);
  });
})();
